/* Where people send feedback or report a problem (shown in the footer of every screen). */
export const FEEDBACK_EMAIL = 'akshayloke@gmail.com';
export const feedbackLine = () =>
  `<span class="feedback">Feedback or a problem? <a href="mailto:${FEEDBACK_EMAIL}?subject=${encodeURIComponent('Mileposts feedback')}">${FEEDBACK_EMAIL}</a></span>`;
